import type { ProductCondition, ProductUnit } from '../api/business/types';

/** The conditions a product may be in (R0030 WP-07) — the API's list. */
export const PRODUCT_CONDITIONS: Array<ProductCondition> = ['NEW', 'USED', 'REFURBISHED'];

/** The units a unit price may be per (R0030 WP-07) — the API's list; the names are `unit.<code>` in `i18n/`. */
export const PRODUCT_UNITS: Array<ProductUnit> = ['kg', 'g', 'l', 'ml', 'm', 'm2', 'piece'];

/** How many characters of `text` there are once trimmed — what the API counts against a limit. */
export const trimmedLength = (text: string): number => text.trim().length;

/**
 * How a counted text stands against its limits: `OK` within what search engines show, `LONG` past that but within
 * what the API takes, `OVER` past what the API takes.
 */
export type LengthState = 'OK' | 'LONG' | 'OVER';

export const lengthState = (length: number, advised: number, maximum: number): LengthState =>
  length > maximum ? 'OVER' : length > advised ? 'LONG' : 'OK';
